import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { router } from "./router";
import { ErrorFallback } from "./components/ErrorFallback";
import "../index.css";

// Global error logger for debugging (dev-only or behind flag)
if (import.meta.env.DEV || localStorage.getItem("DEBUG_ERRORS") === "1") {
  window.addEventListener("error", (e) => console.error("[global onerror]", e.error || e));
  window.addEventListener("unhandledrejection", (e) => console.error("[unhandledrejection]", e.reason || e));
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorFallback>
      <RouterProvider router={router} />
    </ErrorFallback>
  </StrictMode>,
);
